export const ids = {
    badge: {
        frontier: 'div-gpt-ad-1737071676586-0_badge',
    },
    sticky: {
        rentals: ['div-gpt-ad-1691693198409-0_banner'],
        inactive: ['div-gpt-ad-1690212774549-0_banner'],
    },
    dpp: {
        active: {
            mobile: [
                'div-gpt-ad-1669913314017-0', // 0 end of photos (photo pop) — CW-4875
            ],
            desktop: [
                'div-gpt-ad-1669913381824-0', // 0 end of photos (photo pop) — CW-4875
            ],
        },
        inactive: {
            mobile: ['div-gpt-ad-1669913458895-0'], // 0 end of photos (photo pop) — CW-4875
            desktop: ['div-gpt-ad-1669913482498-0'], // 0 end of photos (photo pop) — CW-4875
        },
    },
    msp: {
        desktop: [
            'div-gpt-ad-1645466474208-0_tile',
            'div-gpt-ad-1645466488825-0_tile',
            'div-gpt-ad-1645466502981-0_tile',
            'div-gpt-ad-1651251039914-0_tile',
            'div-gpt-ad-1684347672743-0_tile',
            'div-gpt-ad-1684347722529-0_tile',
        ],
        mobile: [
            'div-gpt-ad-1645657504177-0_tile',
            'div-gpt-ad-1645657517767-0_tile',
            'div-gpt-ad-1645657531755-0_tile',
            'div-gpt-ad-1651251039914-0_tile',
            'div-gpt-ad-1684347672743-0_tile',
            'div-gpt-ad-1684347722529-0_tile',
        ],
        rentals: ['div-gpt-ad-1662680667592-0_tile', 'div-gpt-ad-1662680680003-0_tile', 'div-gpt-ad-1662680691949-0_tile', 'div-gpt-ad-1662680706975-0_tile', 'div-gpt-ad-1681228381331-0_tile'],
        banner: ['div-gpt-ad-1692905567284-0_banner', 'div-gpt-ad-1692905627791-0_banner'],
    },
};
export const getAdsTypeById = (id) => {
    if (!id) {
        return 'default';
    }
    for (const group in ids) {
        const groupVal = ids[group];
        if (!groupVal) continue;

        for (const key in groupVal) {
            const value = groupVal[key];
            if (Array.isArray(value)) {
                for (let i = 0; i < value.length; i++) {
                    if (value[i] && value[i].includes(id)) {
                        return value[i].split('_')[1] || 'default';
                    }
                }
            } else if (value && typeof value === 'object') {
                for (const nestedKey in value) {
                    const nested = value[nestedKey];
                    if (!Array.isArray(nested)) continue;
                    for (let i = 0; i < nested.length; i++) {
                        if (nested[i] && nested[i].includes(id)) {
                            return nested[i].split('_')[1] || 'default';
                        }
                    }
                }
            } else if (typeof value === 'string' && value.includes(id)) {
                return value.split('_')[1] || 'default';
            }
        }
    }
    return 'default';
};
export const getAdsEventCategory = (el, type) => {
    let category = '';
    const needAdsTrack = el.closest('[data-ads-click]');
    if (!el || !needAdsTrack) {
        return category;
    }
    const id = el.closest('[data-ads-click]').getAttribute('id');

    let adsType;
    if (type) {
        adsType = type;
    } else {
        adsType = getAdsTypeById(id);
    }
    category = `ads_${adsType}`;
    if (el.closest('[order]')) {
        const orderEl = el.closest('[order]');
        const parent = orderEl && orderEl.parentElement;
        if (orderEl && parent) {
            const sortedSiblings = Array.from(parent.children)
                .map((node, domIndex) => {
                    const styleOrder = Number(window.getComputedStyle(node).order);
                    const attrOrder = Number(node.getAttribute('order'));
                    let nodeOrder = 0;
                    if (!Number.isNaN(styleOrder)) {
                        nodeOrder = styleOrder;
                    } else if (!Number.isNaN(attrOrder)) {
                        nodeOrder = attrOrder;
                    }
                    return {
                        node,
                        nodeOrder,
                        domIndex,
                    };
                })
                .sort((a, b) => {
                    if (a.nodeOrder !== b.nodeOrder) {
                        return a.nodeOrder - b.nodeOrder;
                    }
                    return a.domIndex - b.domIndex;
                });
            const position = sortedSiblings.findIndex((item) => item.node === orderEl) + 1;
            if (position > 0) {
                category += `_p${position}`;
            }
        }
    } else if (el.closest('[index]')) {
        const rawIndex = Number(el.closest('[index]').getAttribute('index'));
        const adjIndex = isNaN(rawIndex) ? 1 : rawIndex + 1;
        category += `_p${adjIndex}`;
    }

    // console.log('category', category);
    return category;
};
